import ModuleMixin from '@/Mixins/ModuleMixin'
import { EventBus } from '@/app'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.payment',
            forms: {}
        }
    },

    methods: {
        loadPayableByKey(payable_key) {
            return axios({
                method: 'get',
                url: route('api.payments.loadPayableByKey', payable_key)
            })
            .then(response => response.data.data)
        },

        allPayables() {
            return axios({
                method: 'get',
                url: route('api.payments.all.payables')
            })
            .then(response => response.data.data.filter(p => p.is_payable.success))
        },

        addForm(payment_method_slug, component) {
            this.forms[payment_method_slug] = component

            return this
        },

        getForm(payment_method_slug) {
            return this.forms[payment_method_slug]
        },

        status(resource, status) {
            return axios({
                method: 'post',
                url: route('api.payments.status', resource),
                data: {status: status},
                params: {scopes: ['editable']}
            })
            .then(response => {
                if(response.data.success) {
                    this.$alert('Actualización exitosa', 'Listo!', 'success')

                    EventBus.$emit('root', 'payments.statused', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data,message, 'Error!', 'error')

                    return Promise.reject(response.data,message)
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')

                return Promise.reject(Object.values(error.response.data.errors)[0][0])
            })
        }
    },

    created() {
        this.addForm('local.deposit.web', 'local-deposit-web-payment-form')

        this.$Util.formattedClassName['Modules\\Ecommerce\\Entities\\Payment'] = 'Pago'
        this.$Util.tableNameByClassName['Modules\\Ecommerce\\Entities\\Payment'] = 'payments'
        this.$Util.classNameByTableName['payments'] = 'Modules\\Ecommerce\\Entities\\Payment'

        this.$Util.formattedStatus = {
            ...this.$Util.formattedStatus,
            ...{
                'payment.promise': 'No pagado',
                'payment.created': 'En revisión',
                'payment.accepted': 'Aceptado',
                'payment.rejected': 'Rechazado',
                'payment.canceling': 'Cancelándose',
                'payment.cancelled': 'Cancelado',
                'payment.refunded': 'Devuelto',
                'payment.disputed': 'En disputa',
                'payment.chargeback': 'Contracargo'
            }	
        }
    }
}